// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { OwnerGridFragment } from '../../fragments/generated/owner-grid.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetOwnerGridQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOwnerGridQueryResult = { __typename?: 'Query', getOwnerGrid: { __typename?: 'OwnerGridDTO', id: number, searchOnPriceGrid: boolean, inventoryOnPriceGrid: boolean, optionOnPriceGrid: boolean, revenueOnPriceGrid: boolean } };

export const GetOwnerGridGql = gql`
    query GetOwnerGrid {
  getOwnerGrid {
    ...OwnerGrid
  }
}
    ${OwnerGridFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOwnerGridInjectable extends Apollo.Query<GetOwnerGridQueryResult, GetOwnerGridQueryVariables> {
    override document = GetOwnerGridGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */